// extracted by mini-css-extract-plugin
module.exports = {"container":"Phone_container__1SfQU","open":"Phone_open__3VE8E","input":"Phone_input__2O2t2","button":"Phone_button__3s31u","error":"Phone_error__1bluN"};